import React from 'react';
import { useSelector } from 'react-redux';
import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate } from 'utilities/common';

export const SectionProject = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Project.Show']
  );

  const dummy = Array.from({ length: 5 }, (v, i) => i);

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3">
      <div
        className="fw-semibold py-2 border-bottom mb-3"
        style={{ fontSize: 13 }}
      >
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Informasi Project'
        )}
      </div>

      {StateLoading ? (
        dummy?.map((d, i) => (
          <ListHorizontal
            key={i}
            title={<SkeletonText count={1} />}
            content={<SkeletonText count={1} />}
          />
        ))
      ) : (
        <>
          <ListHorizontal title="Customer" content={data?.customer?.company_name !== '' ? `${data?.customer?.company_name} - ${data?.customer?.name}` : data?.customer?.name} />
          <ListHorizontal title="Nama" content={data?.name} />
          <ListHorizontal title="Tipe" content={data?.type} />
          <ListHorizontal title="Invoice Method" content={data?.invoice_method} />
          <ListHorizontal title="Ketentuan Pembayaran" content={`${data?.top} Hari`} />
        </>
      )}
    </section>
  );
};


export const SectionPeriode = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Project.Show']
  );

  const dummy = Array.from({ length: 5 }, (v, i) => i);

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3">
      <div
        className="fw-semibold py-2 border-bottom mb-3"
        style={{ fontSize: 13 }}
      >
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Informasi Periode'
        )}
      </div>

      {StateLoading ? (
        dummy?.map((d, i) => (
          <ListHorizontal
            key={i}
            title={<SkeletonText count={1} />}
            content={<SkeletonText count={1} />}
          />
        ))
      ) : (
        <>
          <ListHorizontal title="Bulan Mulai" content={formatDate(data?.start_monthly, 'YYYYMM')} />
          <ListHorizontal title="Bulan Selesai" content={data?.end_monthly ? formatDate(data?.end_monthly, 'YYYYMM') : ''} />
          <ListHorizontal title="Pengusaha Kena Pajak" content={data?.is_pkp ? 'Ya': 'Tidak'} />
          <ListHorizontal title="PPN" content={data?.ppn} />
          <ListHorizontal title="PPH" content={data?.pph} />
        </>
      )}
    </section>
  );
};
